import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "./BaseElement.js";
import { AddShortlist, RemoveShortlist } from "./icons.js";
import { getCookie, setCookie } from "tiny-cookie";
import { classMap } from "lit/directives/class-map.js";
import { useStores } from "@nanostores/lit";
import {
  addShortlistItem,
  removeShortlistItem,
  shortlist,
} from "./ac101-app.js";

@useStores(shortlist)
@customElement("ac101-shortlist-button")
export class AC101ShortlistButton extends BaseElement {
    @property() id: string;
    @property({attribute: 'data-shortlistid'}) shortListId: string;

  #click(e) {
    e.preventDefault();
    if (this.active) {
      this.remove();
    } else {
      this.add();
    }
  }

    remove() {
      removeShortlistItem(this.shortListId);
      this.requestUpdate();
  }

  add() {
    addShortlistItem(this.shortListId);
    this.requestUpdate();
  }

  get active() {
    return shortlist.get().includes(this.shortListId);
  }
  render() {
    return html`<button
      @click=${this.#click}
      class="${classMap({
        "btn d-block w-100 btn-text": true,

        "btn-text-delete": this.active,
      })}"
    >
      <span class="me-1">${this.active ? RemoveShortlist : AddShortlist}</span>
      Shortlist
    </button>`;
  }
}
